module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 35 35"
    }
  }, [_c('defs'), _c('g', {
    attrs: {
      "id": "Слой_2",
      "data-name": "Слой 2"
    }
  }, [_c('g', {
    attrs: {
      "id": "Слой_1-2",
      "data-name": "Слой 1"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M17.5,35H6.58a6.69,6.69,0,0,1-1.94-.22,2.43,2.43,0,0,1-1.9-2.11c-.46-4-.87-7.94-1.4-11.9C.86,17.12.54,13.45.05,9.8c-.29-2.11.74-3.46,3-3.87,1.89-.35,3.79-.64,5.7-.84a.75.75,0,0,0,.66-.43A8.66,8.66,0,0,1,17.51,0a8.66,8.66,0,0,1,8,4.64.73.73,0,0,0,.66.44c1.91.2,3.81.49,5.7.83,2.38.42,3.39,1.74,3.12,4-.36,2.86-.64,5.73-1,8.6q-.84,7.19-1.74,14.38a2.31,2.31,0,0,1-1.76,1.89,6.21,6.21,0,0,1-2.06.26Zm-.09-20.4a6.75,6.75,0,0,0,7-6.37,6.75,6.75,0,0,0-6.92-6.5,6.74,6.74,0,0,0-7.06,6.42C10.45,11.69,13.53,14.56,17.41,14.6ZM17,24.88v7.76c0,.36.06.7.53.72s.61-.34.6-.73v-.17q0-7.11,0-14.23c0-.41,0-.82,0-1.23a.53.53,0,0,0-.61-.54A.51.51,0,0,0,17,17v7.87Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M17.38,9.69A1.55,1.55,0,0,1,16,8.86a1.37,1.37,0,0,1,.15-1.6,1.52,1.52,0,0,1,1.61-.56.87.87,0,0,0,.92-.28c.63-.6,1.28-1.18,1.92-1.77.28-.27.6-.42.93-.12s.18.59-.11.85C20.72,6,20,6.65,19.35,7.27a.7.7,0,0,0-.27.71A1.56,1.56,0,0,1,17.38,9.69Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M14.07,10.81a.76.76,0,0,1,.44.29c.13.12,0,.21,0,.29l-.71.66c-.11.1-.22.14-.32,0s-.37-.23-.27-.35A11.16,11.16,0,0,1,14.07,10.81Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M14.74,5.14c-.22.16-.36.25-.5.34s-.22,0-.31-.09-.41-.39-.63-.57-.14-.3,0-.47.33-.16.51,0S14.38,4.84,14.74,5.14Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M21.31,12.34c-.35-.38-.62-.69-.91-1s0-.23.08-.33.32-.28.54,0,.41.38.62.58.2.15.09.29Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M17.8,12.87c0,.16,0,.31,0,.46s-.26.27-.42.22c-.58-.18-.18-.62-.27-.94s-.08-.45.3-.45c.19,0,.39,0,.39.25v.46Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M17.1,3.48c0-.22-.11-.5.12-.65a.46.46,0,0,1,.53,0,2.48,2.48,0,0,1,0,1.24.47.47,0,0,1-.52,0C17,4,17.14,3.7,17.1,3.48Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M12.39,7.85h.5c.28,0,.28.23.23.38-.2.53-.68.16-1,.24-.19,0-.49.08-.48-.26,0-.18,0-.36.27-.37Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M22.54,8.49H22c-.3,0-.27-.24-.22-.39.16-.5.63-.18,1-.24s.54-.11.55.27c0,.18,0,.36-.27.36Z"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a6ed772","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIcon/iconsTemplate/contents/bodyMass.vue
// module id = 9b45167e57bc55b4fe8a
// module chunks = 89